import { I18N } from "aurelia-i18n";
import { DataType, QueryFilter, SourceType } from "../../../../../../models/queries/queries.models";
import { transient, autoinject, BindingEngine, useView } from "aurelia-framework";
import { CustomGridPageBase } from "../../../../common/custom-grid-page.base";
import { DeleteListAlertRequest, ListModel } from "../../../../../../models/lists/list.models";
import * as moment from "moment";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { ListService } from "../../../../../../services/modules/list-client.service";
import { RightShipDialogServiceConstants } from "../../../../../../constants/basics/rightship-dialog.constants";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject()
@transient()
@useView('views/pages/admin/lists/list-items-wrapper/steps/list-alert-settings.html')
export class ListAlertSettings extends CustomGridPageBase {
    private list: ListModel;

    public activate(model: ListModel) {
        this.list = model;

        const columns = [];
        columns.push(
            {
                columnOrder: 0,
                sortOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'name',
                title: 'Name'
            },
            {
                columnOrder: 0,
                sortOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'alertInformation',
                title: 'Alert Information'
            },
            {
                columnOrder: 0,
                sortOrder: 0,
                dataType: DataType.Number,
                isSortable: true,
                name: 'recipients',
                title: 'Recipients'
            },
            {
                columnOrder: 0,
                sortOrder: 0,
                dataType: DataType.DateTime,
                isSortable: true,
                name: 'lastModified',
                title: 'Last Modified',
                valueConverter: x => x ? moment(new Date(x)).format(this.configService.config.common.defaultDateTimeFormat) : null
            },
            {
                columnOrder: 0,
                sortOrder: 0,
                dataType: DataType.CustomTemplate,
                instancePerRow: true,
                name: "menu",
                value: `<div class="actions row justify-content-end align-items-middle">
                            <list-menu hide-menu-border="true" menu-items.bind="menuItems(item)">
                                <template replace-part="menu-item">
                                    <div class="row nowrap align-items-middle" click.trigger="menuItem.click($event)">
                                        <span class="text">\${menuItem.item.text}</span>
                                    </div>  
                                </template>
                            </list-menu>
                        </div>`,
                parameter: {
                    item: null,
                    menuItems: (item) => {
                        return [
                            {
                                isVisible: true,
                                click: ($event) => {
                                    if ($event)
                                        $event.stopPropagation();
                                    this.dialogClient.show(RightShipDialogServiceConstants.URLs.ListAlertSettingsDialog, {
                                        onComplete: () => {
                                            this.dataGridVM.reloadData(null, null);
                                        },
                                        id: item ? item.id : null,
                                        isVessel: this.list ? this.list.entityTypeId == EntityTypes.Vessel : false,
                                        isCompany: this.list ? this.list.entityTypeId == EntityTypes.Company : false,
                                        listId: this.list ? this.list.listId : null
                                    }, true, false, false, 'right');
                                },
                                item: { text: "Edit" },
                                classList: ''
                            },
                            {
                                isVisible: true,
                                click: ($event) => {
                                    $event.stopPropagation();
                                    this.dialogClient.show(RightShipDialogServiceConstants.URLs.DeleteModal, {
                                        delete: async () => {
                                            const request: DeleteListAlertRequest = {
                                                allSelected: false,//this.dataGridVM.toggleAll,
                                                filters: this.dataGridVM.allFilters,
                                                ids: [item.id] //this.dataGridVM.getSpecificIds()
                                            };
                                            await this.listService.deleteListAlert(request);
                                            this.dataGridVM.reloadData(null, null);
                                            this.dialogClient.hide();
                                        },
                                        id: item ? item.id : null,
                                        isVessel: this.list ? this.list.entityTypeId == EntityTypes.Vessel : false,
                                        isCompany: this.list ? this.list.entityTypeId == EntityTypes.Company : false,
                                        listId: this.list ? this.list.listId : null
                                    }, true, false, false, 'right');
                                },
                                item: { text: "Remove" },
                                classList: ''
                            }
                        ]
                    }
                }
            });

        this.columns = columns;
        this.itemSource = {
            sourceType: SourceType.ODataUrl,
            source: "odata/ListAlerts",
            columns: this.columns,
            initialFilters: [QueryFilter.getQuery('listId', this.list.listId, 'eq', DataType.Number)]
        };
    }

    constructor(private dialogClient: DialogClientService,
        protected bindingEngine: BindingEngine,
        notificationClientService: NotificationClientService,
        private listService: ListService, private configService: ConfigService,
        i18N: I18N) {
        super(i18N, 'Alert Settings', bindingEngine);
    }

    addSetting() {
        this.dialogClient.show(RightShipDialogServiceConstants.URLs.ListAlertSettingsDialog, {
            onComplete: () => {
                this.dataGridVM.reloadData(null, null);
            },
            id: null,
            isVessel: this.list ? this.list.entityTypeId == EntityTypes.Vessel : false,
            isCompany: this.list ? this.list.entityTypeId == EntityTypes.Company : false,
            listId: this.list ? this.list.listId : null
        }, true, false, false, 'right');
    }
}